<template>
  <div
    class="ws-chip-002"
    :class="[{green:green,yellow:yellow,red:red,outLine:outLine},color]"
  >
    <div class="ws-chip-002__text">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "WsChip002",
  props: {
    color: {
      type: String,
      default: "",
    },
    green: {
      type: Boolean,
      default: false,
    },
    yellow: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
    outLine: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
  },
};
</script>